import { Action } from '@ngrx/store';
import { WalletPaginatorInterface } from '../../models/wallet.paginator.interface';

export enum EWalletActions {
  GetWallet = '[WALLET] Get wallet',
  GetWalletSuccess = '[WALLET] Get wallet success',
  GetWalletFailure = '[WALLET] Get wallet failure'
}

export class GetWallet implements Action {
  public readonly type = EWalletActions.GetWallet;
  constructor(public currentSelectedPage: number, public totalItemsPerPage: number) {}
}

export class GetWalletSuccess implements Action {
  public readonly type = EWalletActions.GetWalletSuccess;
  constructor(public payload: WalletPaginatorInterface) {}
}

export class GetWalletFailure implements Action {
  public readonly type = EWalletActions.GetWalletFailure;
}

export type WalletActions = GetWallet | GetWalletSuccess | GetWalletFailure;
